<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <div class="pt-4 pb-5">
          <img src="@/assets/bos.png" />
        </div>
        <b-jumbotron header="BOŠ partneri" header-level="4">
          <p class="lead">Dobrodošli na platformu za koordinaciju aktivnosti na projektima.</p>
        </b-jumbotron>
      </b-col>
    </b-row>
    <Projects />
  </b-container>
</template>

<script>
import Projects from "@/components/ProjectsTable";

export default {
  components: {
    Projects
  },
  data() {
    return {};
  }
};
</script>

<style>
</style>
